// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mv-c";
export var backButton = "_mv-4";
export var backIcon = "_mv-5";
export var chevronShortcut = "_mv-6";
export var container = "_mv-1";
export var editor = "_mv-8";
export var editorWrapper = "_mv-7";
export var prefix = "_mv-2";
export var searchIcon = "_mv-3";
export var suffix = "_mv-9";
export var suffixContent = "_mv-a";
export var suffixText = "_mv-b";
export var wrapper = "_mv-0";